<template>
  <div class="d-flex flex-column align-items-center">
    <div
      v-if="['choose_resume_template'].includes(pageState.currentStep)"
      class="d-flex"
      style="height: 78vh;"
    >
      <b-overlay
        :show="pageState.isLoading"
        rounded="sm"
        style="height: 100%;"
      >
        <div
          class="h-100 w-100 overflow-auto d-flex flex-row flex-wrap flex-gap-md"
        >
          <div
            v-for="template in resumeTemplates"
            :key="template.id"
            class="d-flex"
            style="width: 24%;"
          >
            <div
              @click="nextStep(null)"
            >
              <img
                class=""
                alt="Resume Template"
                :src="template.image_file_link"
                style="max-width: 100%;"
                @click="chooseTemplate(template)"
              >
            </div>
          </div>
        </div>
      </b-overlay> 
    </div>

    <div
      v-if="['personal_informations'].includes(pageState.currentStep)"
      class="w-100 d-flex flex-column flex-wrap flex-gap-md"
      style="height: 70vh;"
    >
      <h3>Personal Information</h3>

      <div class="w-100 d-flex flex-row flex-wrap flex-gap-lg">
        <b-form-group label="Fullname" label-for="input-name" class="flex-grow-1">
          <b-form-input
            id="input-name"
            v-model="resumeData.personal_informations.name"
            type="text"
            placeholder="Input your name" 
          />
        </b-form-group>

        <b-form-group label="What position are you looking for?" label-for="input-looking_for_position" class="flex-grow-1">
          <b-form-input
            id="input-looking_for_position"
            v-model="resumeData.personal_informations.looking_for_position"
            class="w-50"
            label="test"
            minlength="1"
            placeholder="Input position title"
          />
        </b-form-group>

        <b-form-group label="About Me" label-for="input-about_me" class="flex-break flex-grow-1">
          <b-form-textarea
            id="input-about_me"
            v-model="resumeData.personal_informations.about_me"
            class="w-100"
            minlength="1"
            placeholder="Input description"
          />
        </b-form-group>
      </div>
    </div>

    <div
      v-if="['contact_informations'].includes(pageState.currentStep)"
      class="w-100 d-flex flex-column flex-wrap flex-gap-md"
      style="height: 70vh;"
    >
      <h3>Contact Information</h3>

      <div class="w-100 d-flex flex-row flex-wrap flex-gap-lg">
        <b-form-group label="Fullname" label-for="input-name" class="flex-grow-1">
          <b-form-input
            id="input-name"
            v-model="resumeData.personal_informations.name"
            type="text"
            placeholder="Input your name" 
          />
        </b-form-group>

        <b-form-group label="What position are you looking for?" label-for="input-looking_for_position" class="flex-grow-1">
          <b-form-input
            id="input-looking_for_position"
            v-model="resumeData.personal_informations.looking_for_position"
            class="w-50"
            label="test"
            minlength="1"
            placeholder="Input position title"
          />
        </b-form-group>

        <b-form-group label="About Me" label-for="input-about_me" class="flex-break flex-grow-1">
          <b-form-textarea
            id="input-about_me"
            v-model="resumeData.personal_informations.about_me"
            class="w-100"
            minlength="1"
            placeholder="Input description"
          />
        </b-form-group>
      </div>
    </div>

    <div
      v-if="['generate_resume'].includes(pageState.currentStep)"
      class="d-flex flex-row flex-gap-md"
    >
      <img
        class=""
        alt="Resume Template"
        :src="selectedTemplate.image_file_link"
        style="max-width: 25%;"
        @click="generateUserResume()"
      >
    </div>

    <div
      v-if="!['choose_resume_template'].includes(pageState.currentStep)"
      class="d-flex flex-gap-md mt-1"
    >
      <b-button
        @click="prevStep(null)"
      >
        Previous
      </b-button>

      <b-button
        @click="nextStep(null)"
      >
        Next
      </b-button>
    </div>

    <div
      v-if="false"
      class=""
    >
      <AddResumeTemplate />
    </div>
  </div>
</template>

<script>

import {
  cloneDeep, debounce, difference, orderBy,
} from 'lodash'

import AddResumeTemplate from './AddResumeTemplate.vue'

export default {
  components: {
    AddResumeTemplate,
  },
  
  props: {
    popupResumeGenerator: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      pageState: {
        steps: [],
        currentStep: '',
      },

      resumeTemplates: [],
      selectedTemplate: null,

      resumeData: {},
      resumeData: {
        personal_informations: {
          name: 'MICHAEL CHUA',
          looking_for_position: 'WEB DEVELOPER',
          about_me: `I am a qualified and professional web developer with five years of experience in database administration and website design. Strong creative and analytical skills. Team player with an eye for detail.`,
        },
        contact_informations: {
          email: 'michael@gmail.com',
          email_mask: true,
          phone_number: '86345511',
          phone_number_mask: false,
          residential_address: '184B Tiong Bahru Road, #40-02, Singapore 180184',
          website: 'www.michael-chua.com.sg',
        },
        employments: [
          {
            position_title: 'WEB APPLICATIONS DEVELOPER',
            company: 'Google',
            start_date: new Date('2016-02-12'),
            end_date: new Date('2023-02-03'),
            still_work_here: true,
            job_description: '• Collaborate with cross-functional teams such as designers, product managers and stakeholders to ensure high-quality and timely delivery. \n• Integrating web applications with databases and third-party APIs.',
          },
          {
            position_title: 'WEB APPLICATIONS DEVELOPER',
            company: 'Facebook',
            start_date: new Date('2014-02-14'),
            end_date: new Date('2016-01-06'),
            still_work_here: false,
            job_description: '• Analyse user requirements and determining technical feasibility. \n• Designing, coding, testing and debugging web applications. \n• Ensuring web applications are secure, scalable and perform optimally.',
          },
          {
            position_title: 'UX/UI DESIGNER',
            company: 'Great Eastern',
            start_date: new Date('2010-04-08'),
            end_date: new Date('2014-01-02'),
            still_work_here: false,
            job_description: '• Conduct user research and testing to understand user needs and behaviour. \n• Designed wireframes, prototypes and visual interfaces to effectively communicate design concepts.',
          },
        ],
        educations: [
          {
            field_of_study: 'DIPLOMA IN INFORMATION TECHNOLOGY (IT)',
            institution: 'NGEE ANN POLYTECHNIC',
            start_date: new Date('2017-06-08'),
            end_date: new Date('2020-07-10'),
            still_study_here: false,
            description: '',
          },
          {
            field_of_study: 'O\'LEVEL CERTIFICATE',
            institution: 'FUHUA SECONDARY SCHOOL',
            start_date: new Date('2013-06-12'),
            end_date: new Date('2016-07-15'),
            still_study_here: false,
            description: '',
          },
        ],
        soft_skills: ['Strong Communication', 'Team Work'],
        hard_skills: ['Web Design', 'Design Thinking', 'Front End Coding', 'Problem-Solving', 'Project Management Tools'],

        pdf_file_link: null,
        ms_word_file_link: null,
      },
    }
  },

  watch: {
    'pageState.currentStep': {
      deep: true,
      handler(newVal) {
        //
      },
    },

  },
  created() {
    this.initComponent()
  },
  methods: {
    initComponent() {
      this.pageState.steps.push('choose_resume_template')
      this.pageState.steps.push('personal_informations')
      this.pageState.steps.push('contact_informations')
      this.pageState.steps.push('education_informations')
      this.pageState.steps.push('employment_informations')
      this.pageState.steps.push('skills_informations')
      this.pageState.steps.push('generate_resume')

      this.pageState.currentStep = this.pageState.steps[0]

      this.getUserData()
      this.getResumeTemplates()
    },

    nextStep(stepName) {
      if (this.$isNotEmpty(stepName)) {
        this.pageState.currentStep = stepName
      } else {
        stepName = this.pageState.steps[this.pageState.steps.indexOf(this.pageState.currentStep) +1]
      }

      if (this.$isNotEmpty(stepName)) {
        this.pageState.currentStep = stepName
      }
    },
    prevStep(stepName) {
      if (this.$isNotEmpty(stepName)) {
        this.pageState.currentStep = stepName
      } else {
        stepName = this.pageState.steps[this.pageState.steps.indexOf(this.pageState.currentStep) -1]
      }

      if (this.$isNotEmpty(stepName)) {
        this.pageState.currentStep = stepName
      }
    },

    getResumeTemplates() {
      this.pageState.isLoading = true
      this.resumeTemplates = []

      this.$http
        .get(`/api/resume-templates`)
        .then(response => {
          const { success, message, output } = response.data
          if (!success) {
            this.pageState.isLoading = false
            this.$toastDanger()
            return
          }
          this.resumeTemplates = output
          this.selectedTemplate = output[1]
          this.pageState.isLoading = false
        })
        .catch(error => {
          this.pageState.isLoading = false
          // this.$handleResponseError(error)
        })
    },

    postResumeTemplate() {
      this.isLoading = true
      this.formData.append('form_data', JSON.stringify({
        title: 'template'
      }))

      const headers = {
        'Content-Type': 'multipart/form-data',
      }

      this.$http
        .post(
          `/api/resume-templates`,
          this.formData,
          {
            headers,
          },
        )
        .then(response => {
          const { success, message, output } = response.data
          if (success) {
            // this.businessCard = output
            this.$toastSuccess('Operation Success', message)

            // const route = this.$router.resolve({ name: 'business-cards-payment-success', params: { id: this.businessCard.id } }).href
            // this.stripeReturnUrl = new URL(route, window.location.origin).href

            // this.formType = 'edit'
            // this.cardId = this.businessCard.id

            this.isLoading = false

            // this.$refs.refBusinessCardWizard.nextTab()
            // this.$emit('refresh-record')
            this.resumeTemplate = output
            this.nextStep()
          }
        })
        .catch(error => {
          this.$handleResponseError(error)
          this.isLoading = false
        })

      this.uploadedResume = this.templates[0] // placeholder
    },

    getUserData(id=null) {
      if (this.$isEmpty(id)) {
        id = this.$store.state.auth.ActiveUser.id
      }

      this.$http
        .get(`/api/user`)
        .then(response => {
          const { data } = response

          this.resumeData.id = data.id
          this.resumeData.fullname = data.fullname
          this.resumeData.email_address = data.email_address
          this.resumeData.phone_number = data.phone_number

        })
        .catch(error => {})
    },

    chooseTemplate(template) {
      this.selectedTemplate = template
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
